import React from 'react';

import './AdminProgressBar.css';

const AdminProgressBar = ({ progress, message = 'Uploading' }) => {
  return (
    <div className='upload-status'>
      <p>
        {message}... {progress}%
      </p>
      <div className='progress-bar'>
        <div className='progress-bar-fill' style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};

export default AdminProgressBar;
